import axios from "axios"; 
import { ElMessage } from 'element-plus'

//let Obj = window.location;
//let url = `${Obj.protocol}//${Obj.host}${Obj.pathname}#`;

//axios.defaults.baseURL = "" + import.meta.env.VITE_BASE_URL;
 
const SERVICEDEFAULT = axios.create({
  timeout: 60 * 1000 * 60,
});

SERVICEDEFAULT.interceptors.request.use(
  (config) => {
     
    let token = localStorage.getItem("loginUserToken");
    if (token != null) {
      config.headers.Authorization = `Bearer ` + token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
SERVICEDEFAULT.interceptors.response.use(
  (response) => {
    if (response.data.code === 401) {
      console.log("token 失效", response.data);
      // ElMessage.error(response.data.msg);
      // localStorage.removeItem("loginUserToken");
      // localStorage.removeItem("loginUser");
      // window.location.href = "/web/index";
    } 
    return response.data;
  },
  (error) => {
    if (error && error.response) {
      ElMessage.error(error.response.data.message || error.response.data.error); 
      if (error.response.status === 401) {
        console.log("退出登录 401"); 
        // localStorage.removeItem("loginUserToken");
        // localStorage.removeItem("loginUser");
        // window.location.href = "/web/index";
      }
    } 
    return Promise.reject(error);
  }
);

SERVICEDEFAULT.all = axios.all; // all方法没有挂载到 axios 实例对象中

function UploadFile(url, data) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data;charset=UTF-8",
        },
      })
      .then(
        (res) => {
          let data = res.data;
          let hasOwnProperty = Object.prototype.hasOwnProperty;
          if (hasOwnProperty.call(res, "data")) {
            let result = res.data;
            if (result.success) {
              resolve(result);
            } else {
              ElMessage({
                message: result.msg || result.message || "上传失败",
                type: "warning",
              });
              reject(result.msg);
            }
          } else {
            ElMessage({
              message: data.message,
              type: "warning",
            });
          }
        },
        (err) => {
          reject(err);
          ElMessage({
            message: "上传失败",
            type: "warning",
          });
        }
      );
  });
}

export { SERVICEDEFAULT, UploadFile };
